import React from "react";
import { Container } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import PromotionTile from "./PromotionTile";
import validatePromotion from "../utils/validate-promotion";

export default function FeaturedPromotion() {
	const user = useSelector((state) => state.user.data);

	/** List of all promotions available, already sorted by rank */
	const promotionsList = useSelector((state) => state.promotions.list || []);

	/** Promotions applicable to the player */
	const promotions = promotionsList ? promotionsList.filter(promotion => validatePromotion(promotion, user)) : [];

	/** First promotion in the list */
	const promotion = promotions[0];

	return (
		<>
			<Container fluid="lg" className="section-margin animate__animated animate__faster animate__fadeIn">
				<PromotionTile promotion={promotion} featured />
			</Container>
		</>
	);
}